import appStore from 'stores/AppStore';

export default function(WrappedComponent) {
  return class extends WrappedComponent {
    appStore = appStore;
  }
}



// WEBPACK FOOTER //
// ./src/decorators/withAppStore.js